import { render, staticRenderFns } from "./SocialInfoSeparator.vue?vue&type=template&id=134ecad8&scoped=true"
import script from "./SocialInfoSeparator.vue?vue&type=script&lang=js"
export * from "./SocialInfoSeparator.vue?vue&type=script&lang=js"
import style0 from "./SocialInfoSeparator.vue?vue&type=style&index=0&id=134ecad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ecad8",
  null
  
)

export default component.exports